var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascriptLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9882 24.844C32.5164 27.3393 34.5047 29.1734 38.0211 29.1734C40.9752 29.1734 42.8623 27.697 42.8623 25.6569C42.8623 23.2123 40.9234 22.3464 37.6719 20.9242L35.8896 20.1594C30.745 17.9677 27.3272 15.2219 27.3272 9.41737C27.3272 4.07042 31.4013 0 37.7682 0C42.3011 0 45.5599 1.57759 47.9082 5.70823L42.3565 9.27286C41.1342 7.0811 39.8155 6.21763 37.7682 6.21763C35.68 6.21763 34.3566 7.54233 34.3566 9.27286C34.3566 11.4116 35.6813 12.2775 38.7401 13.6022L40.5224 14.3657C46.5799 16.9633 50 19.6115 50 25.5654C50 31.9841 44.9577 35.5006 38.1861 35.5006C31.5651 35.5006 27.2875 32.3454 25.1945 28.21L30.9882 24.844ZM5.80337 25.4618C6.92334 27.4489 7.94215 29.1288 10.3916 29.1288C12.7339 29.1288 14.2116 28.2124 14.2116 24.649V0.407039H21.3408V24.7453C21.3408 32.1275 17.0127 35.4874 10.6951 35.4874C4.98687 35.4874 1.68116 32.5333 0 28.9753L5.80337 25.4618Z",
    fill: "#CB5CE6",
    fillOpacity: 0.52
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascriptLight);
export default __webpack_public_path__ + "static/media/javascript_light.7300d246bfe4a05bb401e6af95030bcf.svg";
export { ForwardRef as ReactComponent };